import cardInput from 'utilities/card-input';

export default {
  addresses: (app) => {
  /**
   * This collection of functions + elements handles toggling the billing address, based on the state of the `Billing Same as Shipping` checkbox.
   */
  const $addressCloneToggle = document.getElementById('js-address-clone-toggle');
  const $shippingAddress = document.getElementById('js-shipping-address');
  const $billingAddress = document.getElementById('js-billing-address');

  const hideAddress = ($address) => {
    $address.style.display = 'none';
    disableInputsWithin($address);
  };

  const showAddress = ($address) => {
    $address.style.display = 'block';
    enableInputsWithin($address);
  };

  const disableInputsWithin = ($el) => {
    const $inputs = $el.querySelectorAll('input, textarea, select');
    $inputs.forEach($input => $input.disabled = true);
  };

  const enableInputsWithin = ($el) => {
    const $inputs = $el.querySelectorAll('input, textarea, select');
    $inputs.forEach($input => $input.disabled = false);
  };

  $addressCloneToggle.addEventListener('change', (e) => {
    if ($addressCloneToggle.checked) {
      hideAddress($billingAddress);
    } else {
      showAddress($billingAddress);
    }
  });

   // Fire an initial event to sync the initial state with the checkbox:
  $addressCloneToggle.dispatchEvent(new Event('change'));

   /**
   * Set up country/state dependency:
   */
  const $addressFieldsets = document.querySelectorAll('.js-checkout-addresses__address');

  $addressFieldsets.forEach(($fieldset) => {
    const $countrySelector = $fieldset.querySelector('.js-country-select');
    const $stateSelect = $fieldset.querySelector('.js-state-select');
    const $stateInput = $fieldset.querySelector('.js-state-input');
    const $stateSelInput = $fieldset.querySelector('.js-state-sel-input');
    const $selectPlaceholder = $fieldset.querySelector('.js-select-placeholder');
    const $stateSelValue = $fieldset.querySelector('.js-state-sel-value');

    $countrySelector.addEventListener('change', (e) => {
      const $selectedCountry = $countrySelector.options[$countrySelector.selectedIndex];
      $stateSelect.querySelectorAll('option').forEach( state => { 
        state.selected = false
      })

      // Coerce to integer, because data-attrs are strings, by default. `requiresState` will be either '0' or '1', which as integers will satisfy our test:
      if (parseInt($selectedCountry.dataset.requiresState)) {
        // Enable select menu:
        $stateSelect.style.display = 'block';
        $stateSelect.disabled = false;
        $stateSelect.querySelectorAll('optgroup').forEach( group => {
          group.style.display = 'block'
        });

        // Filter optgroups
        $stateSelect.querySelectorAll('optgroup').forEach( group => {
          // Hide states outside of selected country
          if (group.getAttribute('label') !== $selectedCountry.textContent ) {
            group.style.display = 'none'
          // Select the first filtered state as a default
          } else {
            if ($stateSelInput.value != ''){
              //$stateSelect.val($stateSelInput.value);
              $stateSelect.querySelectorAll('option').forEach(function(option, index) {
                if (option.value == $stateSelInput.value){
                  $stateSelect.selectedIndex = index;
                  return;
                }
              });
            }
            else{
              group.children[0].selected = true 
            }
          }
        })
         // Disable arbitrary text input:
        $stateInput.style.display = 'none';
        $stateInput.disabled = true;
      } else {
        // Disable select menu:
        $stateSelect.style.display = 'none';
        $stateSelect.disabled = true

         // Enable arbitrary text input:
        $stateInput.style.display = 'block';
        $stateInput.disabled = false;
      }
    });

    $countrySelector.dispatchEvent(new Event('change'));

    $stateSelect.addEventListener('change', (e) => {
      $stateSelInput.setAttribute('value', $stateSelect.selectedIndex+1);
      $stateSelValue.setAttribute('value', $stateSelect.selectedIndex+1);
    });
  });

  // set US state based on zipcode - Billing Address
  //const $shippingAddress = document.querySelector('.checkout-addresses__address--shipping');
  const $zipLabel = $shippingAddress.querySelector('.form__field--name-zip');
  const $zipField = $zipLabel.querySelector('.form__input');
  const $postalCode =  document.querySelector('[name="shippingAddress[zipCode]"]');
  const $statesSelector =  document.querySelector('.js-state-select');
  const $countrySelector = $shippingAddress.querySelector('.js-country-select');
  const $stateSelValue = $shippingAddress.querySelector('.js-state-sel-value');
  const $stateSelInput = $shippingAddress.querySelector('.js-state-sel-input');

  var is_int = function(value) {
    if ((parseFloat(value) == parseInt(value)) && !isNaN(value)) {
      return true;
    } else {
      return false;
    }
  }

  $zipField.addEventListener('keyup', el => {

    if ( ($countrySelector.value == 233) && ($postalCode.value.length == 5) && (is_int($postalCode.value)) ) {

      var xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://zip.getziptastic.com/v2/US/' + $postalCode.value);
      xhr.send(null);

      xhr.onreadystatechange = function () {
        var DONE = 4; // readyState 4 means the request is done.
        var OK = 200; // status 200 is a successful return.
        if (xhr.readyState === DONE) {
          if (xhr.status === OK) {
            var res = JSON.parse(xhr.response);
            if (res.state != '') {
              $statesSelector.querySelectorAll('option').forEach(function(option, index) {
                if (option.text == res.state){
                  $statesSelector.selectedIndex = index;
                  $stateSelValue.setAttribute('value', index+1);
                  $stateSelInput.setAttribute('value', index+1);
                  $statesSelector.setAttribute('disabled', 'disabled');
                  return;
                }
              });
            }
            else{
              $statesSelector.disabled = false; 
            }
          }
        } 
      };
    }
    else{
      $statesSelector.disabled = false; 
    }
  });

  // set US state based on zipcode - Billing Address
  const $zipLabel1 = $billingAddress.querySelector('.form__field--name-zip');
  const $zipField1 = $zipLabel1.querySelector('.form__input');
  const $postalCode1 =  document.querySelector('[name="billingAddress[zipCode]"]');
  const $statesSelector1 =  document.querySelector('[name="billingAddress[stateId]"]');
  const $countrySelector1 = $billingAddress.querySelector('[name="billingAddress[countryId]"]');
  const $stateSelValue1 = $billingAddress.querySelector('.js-state-sel-value');
  const $stateSelInput1 = $billingAddress.querySelector('.js-state-sel-input');

  $zipField1.addEventListener('keyup', el => {
    if ( ($countrySelector1.value == 233) && ($postalCode1.value.length == 5) && (is_int($postalCode1.value)) ) {

      var xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://zip.getziptastic.com/v2/US/' + $postalCode1.value);
      xhr.send(null);

      xhr.onreadystatechange = function () {
        var DONE = 4; // readyState 4 means the request is done.
        var OK = 200; // status 200 is a successful return.
        if (xhr.readyState === DONE) {
          if (xhr.status === OK) {
            var res = JSON.parse(xhr.response);
            if (res.state != '') {
              $statesSelector1.querySelectorAll('option').forEach(function(option, index) {
                if (option.text == res.state){
                  $statesSelector1.selectedIndex = index;
                  $stateSelValue1.setAttribute('value', index+1);
                  $stateSelInput1.setAttribute('value', index+1);
                  $statesSelector1.setAttribute('disabled', 'disabled');
                  return;
                }
              });
            }
            else{
              $statesSelector1.disabled = false;
            }
          }
        } 
      };
    }
    else{
      $statesSelector1.disabled = false;
    } 
  });
  
  if ($billingAddress.querySelector('.form__field-errors') !== null && $billingAddress.querySelector('.form__field-errors').textContent.length > 0){
    showAddress($billingAddress);
  }
  },

  payment: (app) => {
    const $cardField = document.querySelector('.js-form__field--type-card');
    cardInput($cardField);
  }
}
